import {
  FETCH_TRANSLATION_MAP_REQUEST,
  FETCH_TRANSLATION_MAP_SUCCESS,
  FETCH_TRANSLATION_MAP_FAILURE,
  FETCH_RIGHTS_REQUEST,
  FETCH_RIGHTS_SUCCESS,
  FETCH_RIGHTS_FAILURE,
  FETCH_SUBRIGHTS_REQUEST,
  FETCH_SUBRIGHTS_SUCCESS,
  FETCH_SUBRIGHTS_FAILURE,
  FETCH_LEARNMORES_REQUEST,
  FETCH_LEARNMORES_SUCCESS,
  FETCH_LEARNMORES_FAILURE,
  ADD_OR_EDIT_RIGHTS_REQUEST,
  ADD_OR_EDIT_RIGHTS_FAILURE,
  ADD_OR_EDIT_RIGHTS_SUCCESS,
  SET_SELECTED_RIGHT_CATEGORY,
  SET_SELECTED_SUBRIGHT,
  FETCH_ORGS_REQUEST,
  FETCH_ORGS_SUCCESS,
  FETCH_ORGS_FAILURE,
} from "../../constants/ActionType";

const initialState = {
  isAddEditRightsLoading: false,
  isTranslationMapLoading: false,
  isRightsLoading: false,
  isSubrightsLoading: false,
  isLearnMoresLoading: false,
  isOrgsLoading: false,
  errMessage: "",
  translationMap: {},
  orgs: [],
  rights: [],
  subrights: [],
  learnMores: [],
  selectedRightCategory: null,
  selectedSubright: null,
};

const rightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSLATION_MAP_REQUEST:
      return {
        ...state,
        isTranslationMapLoading: true,
        errMessage: "",
      };
    case FETCH_TRANSLATION_MAP_SUCCESS:
      return {
        ...state,
        isTranslationMapLoading: false,
        translationMap: action.payload.translationMap,
      };
    case FETCH_TRANSLATION_MAP_FAILURE:
      return {
        ...state,
        isTranslationMapLoading: false,
        translationMap: {},
        errMessage: action.payload.errMessage,
      };
    case FETCH_RIGHTS_REQUEST:
      return {
        ...state,
        isRightsLoading: true,
        errMessage: "",
        rights: [],
        subrights: [],
        learnMores: [],
      };
    case FETCH_RIGHTS_SUCCESS:
      return {
        ...state,
        isRightsLoading: false,
        rights: action.payload.rightsArr,
      };
    case FETCH_RIGHTS_FAILURE:
      return {
        ...state,
        isRightsLoading: false,
        rights: [],
        errMessage: action.payload.errMessage,
      };
    case FETCH_SUBRIGHTS_REQUEST:
      return {
        ...state,
        isSubrightsLoading: true,
        subrights: [],
        learnMores: [],
        errMessage: "",
      };
    case FETCH_SUBRIGHTS_SUCCESS:
      return {
        ...state,
        isSubrightsLoading: false,
        subrights: action.payload.subrightsArr,
      };
    case FETCH_SUBRIGHTS_FAILURE:
      return {
        ...state,
        isSubrightsLoading: false,
        errMessage: action.payload.errMessage,
      };
    case FETCH_LEARNMORES_REQUEST:
      return {
        ...state,
        isLearnMoresLoading: true,
        learnMores: [],
        errMessage: "",
      };
    case FETCH_LEARNMORES_SUCCESS:
      return {
        ...state,
        isLearnMoresLoading: false,
        learnMores: action.payload.learnMoresArr,
      };
    case FETCH_LEARNMORES_FAILURE:
      return {
        ...state,
        isLearnMoresLoading: false,
        errMessage: action.payload.errMessage,
      };
    case ADD_OR_EDIT_RIGHTS_REQUEST:
      return {
        ...state,
        isAddEditRightsLoading: true,
        errMessage: "",
      };
    case ADD_OR_EDIT_RIGHTS_SUCCESS:
      return {
        ...state,
        isAddEditRightsLoading: false,
      };
    case ADD_OR_EDIT_RIGHTS_FAILURE:
      return {
        ...state,
        isAddEditRightsLoading: false,
        errMessage: action.payload.errMessage,
      };
    case SET_SELECTED_RIGHT_CATEGORY:
      return {
        ...state,
        selectedRightCategory: action.payload.selectedRightCategory,
      };
    case FETCH_ORGS_REQUEST:
      return {
        ...state,
        errMessage: "",
        isOrgsLoading: true,
      };
    case FETCH_ORGS_SUCCESS:
      return {
        ...state,
        orgs: action.payload.orgs,
        isOrgsLoading: false,
      };
    case FETCH_ORGS_FAILURE:
      return {
        ...state,
        isOrgsLoading: false,
        errMessage: action.payload.errMessage,
      };
    case SET_SELECTED_SUBRIGHT: {
      return {
        ...state,
        selectedSubright: action.payload.selectedSubright,
      };
    }
    default:
      return state;
  }
};

export default rightsReducer;
